var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"picBox"},[_c('vue-preview',{staticClass:"preview",staticStyle:{"display":"inline-block"},attrs:{"slides":_vm.details}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }